import { Identity } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { LeaveRegistration } from '../model/out/leave-registration';
import { Observable } from 'rxjs';
import { Transport } from '../model/Transport';
import { AreaGate } from '../model/areaGate';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class RegisterLeaveService {

  constructor(private appServerAPI: AppServerAPI) { }

  getAreaGates() {
    return this.appServerAPI.execute<AreaGate[]>(`/client/control/transport/register/leave/area-gates`, {}).pipe(map(response => {
      const gates = new Array<AreaGate>();
      for (const entry of response) {
        gates.push(new AreaGate(entry));
      }
      return gates;
    }));
  }

  getTransport(identity: Identity): Observable<Transport> {
    return this.appServerAPI.execute<Transport>(`/client/control/transport/register/leave/transport`, identity);
  }

  accept(identity: LeaveRegistration): Observable<any> {
    return this.appServerAPI.execute<any>(`/client/control/transport/register/leave/accept`, identity);
  }

  decline(identity: LeaveRegistration) {
    return this.appServerAPI.execute<any>(`/client/control/transport/register/leave/decline`, identity);
  }
}
